/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useMemo,
  useLayoutEffect,
} from "react";
import Col from "../../UIcomponent/Column";
import "./AvailabiltySchedule.scss";
import DateTime from "../../Utility/Method/DateTime";
import nextIcon from "../../Assets/icon/nextIcon.png";
import previousIcon from "../../Assets/icon/previousIcon.png";
import Image from "../../UIcomponent/Image";
import moment from "moment-jalaali";
import LocalContext from "../../Context/LocalContetxt";
import closeIcon from "../../Assets/icon/closeIcon.png";
import { ThemeContext } from "styled-components";
import LocalBooking from "../../Utility/Method/LocalBooking";
import { StatusList } from "../../Utility/StatusList";
import { StatusObj } from "../CalendarSchedule/Utility/StatusObj";
import LocalAppConfig from "../../Utility/Method/LocalAppConfig";

const AvailabiltySchedule = (props) => {
  const lang = useContext(LocalContext).lang;
  const {
    localSave,
    hasData,
    mini,
    Data,
    SessionCount,
    Slot,
    onNextWeek,
    onPreviousWeek,
    loading,
    Loader,
    onSelect,
    onDeselect,
    onRemove,
    role,
    breakPoints,
  } = props;
  const [didMount, setDidMount] = useState([]);
  const [DateStatus, setDateStatus] = useState([]);
  const [weeklyCell, setWeeklyCell] = useState([]);

  const theme = useContext(ThemeContext);
  const appConfig = LocalAppConfig.Get();
  const MinimumBookingIntervalInMinute =
    Number(appConfig.MinimumBookingIntervalInMinute) / 60 || 0;
  let localBook = localSave === true ? LocalBooking.Get() : null;
  let Refs = [];
  const setRef = (ref) => {
    Refs.push(ref);
  };
  const DropRef = useRef();
  let step = props.duration || 0.5;
  let now = new Date(
    Date.now() + MinimumBookingIntervalInMinute * 60 * 60 * 1000
  );
  let todayYear = Number(now.getFullYear(now));
  let todayMonth = Number(now.getMonth(now));
  let todayDate = Number(now.getDate(now));

  const WeekDay = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const PersianMonth = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];

  const [firstDay, setFirstDay] = useState({
    Day: todayDate,
    Month: todayMonth,
    Year: todayYear,
  });

  const [showDropdown, setShowDropdown] = useState(false);
  let row = props.row || 6;
  let allDay = [];
  let Week = [];

  allDay = [
    {
      id: moment(
        new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
      ).valueOf(),
      INDEX: 0,
      status: 0,
      Start: 0,
      End: step,
      startHour: 0,
      startMin: 0,
      endHour: Math.floor(step),
      endMin: step % 1 !== 0 ? 30 : 0,
      date: moment(
        new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
      ),
      date_time: moment(
        new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
      ).format("YYYY-MM-DDTHH:mm:ssZ"),
      weeklyIndex: 0,
    },
  ];

  let DateStatusInBook =
    DateStatus && DateStatus.length > 0
      ? DateStatus.filter((each) => each.status === 3)
      : 0;

  let leftChoise = SessionCount - DateStatusInBook.length;

  for (let i = 1; i <= 7 * (24 / step); i++) {
    allDay.push({
      id: moment(
        new Date(
          firstDay.Year,
          firstDay.Month,
          firstDay.Day,
          0,
          i * step * 60,
          0
        )
      ).valueOf(),
      INDEX: i,
      status: 0,
      Start: allDay[i - 1].End,
      End: allDay[i - 1].End + step,
      startHour:
        allDay[i - 1].End < 24
          ? Math.floor(allDay[i - 1].End)
          : Math.floor(allDay[i - 1].End) % 24,
      startMin: allDay[i - 1].End % 1 !== 0 ? 30 : 0,
      endHour:
        allDay[i - 1].End < 24
          ? Math.floor(allDay[i - 1].End + step)
          : Math.floor(allDay[i - 1].End + step) % 24,
      endMin: (allDay[i - 1].End + step) % 1 !== 0 ? 30 : 0,
      date: moment(
        new Date(
          firstDay.Year,
          firstDay.Month,
          firstDay.Day,
          0,
          i * step * 60,
          0
        )
      ),
      date_time: moment(
        new Date(
          firstDay.Year,
          firstDay.Month,
          firstDay.Day,
          0,
          i * step * 60,
          0
        )
      ).format("YYYY-MM-DDTHH:mm:ssZ"),
      ColumnIndex: Number((i / 48).toString()[0]),
      RowIndex: null,
    });
  }

  let startIndex;
  let endIndex;
  let startKey = moment(
    new Date(firstDay.Year, firstDay.Month, firstDay.Day)
  ).valueOf();
  let endKey = startKey + 7 * 24 * 60 * 60 * 1000;

  // Mapper
  DateStatus &&
    DateStatus.map((avai, i) => {
      let avaiFromHour = Number(moment(avai.date_time_from).format("H"));
      let avaiFromMinute = Number(moment(avai.date_time_from).format("mm"));
      let avaiToHour = Number(moment(avai.date_time_to).format("H"));
      let avaiToMinute = Number(moment(avai.date_time_to).format("mm"));
      let fromColumnIndex;
      let toColumnIndex;
      let SlotMonthDate = moment(avai.date_time_to).format("MMDD");
      let MonthPlus = firstDay.Month + 1;
      let fistDayMonthStr = `${MonthPlus < 10 ? "0" + MonthPlus : MonthPlus}${
        firstDay.Day < 10 ? "0" + firstDay.Day : firstDay.Day
      }`;
      if (SlotMonthDate >= fistDayMonthStr) {
        const newFirstDay = new Date(
          firstDay.Year,
          firstDay.Month,
          firstDay.Day,
          0,
          0,
          0
        );

        const nowFrom2 = new Date(avai.date_time_from);
        const todayYear1 = Number(nowFrom2.getFullYear(nowFrom2));
        const todayMonth1 = Number(nowFrom2.getMonth(nowFrom2));
        const todayDate1 = Number(nowFrom2.getDate(nowFrom2));
        const nowTo2 = new Date(avai.date_time_to);
        const todayYear2 = Number(nowTo2.getFullYear(nowTo2));
        const todayMonth2 = Number(nowTo2.getMonth(nowTo2));
        const todayDate2 = Number(nowTo2.getDate(nowTo2));

        const newFromDay = new Date(
          todayYear1,
          todayMonth1,
          todayDate1,
          0,
          0,
          0
        );
        const newToDay = new Date(todayYear2, todayMonth2, todayDate2, 0, 0, 0);

        const FirstS = Math.round(newFirstDay.getTime() / 1000);
        const ToS = Math.round(newToDay.getTime() / 1000);
        const FromS = Math.round(newFromDay.getTime() / 1000);

        toColumnIndex = Number(((ToS - FirstS) / 60 / 60 / 24).toFixed(0));
        fromColumnIndex = Number(((FromS - FirstS) / 60 / 60 / 24).toFixed(0));
      }
      let fromRowIndex;
      let toRowIndex;
      fromRowIndex = avaiFromHour / step;
      toRowIndex = avaiToHour / step;
      if (avaiFromMinute === 30) {
        fromRowIndex = avaiFromHour / step + 1;
      }
      if (avaiToMinute === 30) {
        toRowIndex = avaiToHour / step + 1;
      }
      startIndex = Number(fromColumnIndex * 48 + fromRowIndex);
      endIndex =
        Number(toColumnIndex * 48 + toRowIndex) < 337
          ? Number(toColumnIndex * 48 + toRowIndex)
          : 336;

      let bookedItem = allDay.filter((each) => each.status === 3);
      let lastBookIndex;
      if (!mini) {
        if (bookedItem.length > 0 && startIndex - lastBookIndex < Slot) {
          lastBookIndex = bookedItem[bookedItem.length - 1].INDEX;
          for (let y = lastBookIndex + 1; y < startIndex; y++) {
            allDay[y].status = allDay[y].status == 0 ? 0 : 4;
          }
        }
      }
      if (isNaN(startIndex) === false && isNaN(endIndex) === false) {
        if (avai.id === undefined) {
          for (let x = startIndex; x < endIndex; x++) {
            if (allDay[x]) {
              allDay[x].status = avai.status;
              if (x == endIndex - 1 && avai.status === 1) {
                allDay[x].status = avai.status;
              }
            }
          }
        } else {
          if (startKey <= avai.id && avai.id <= endKey) {
            for (let j = avai.INDEX; j < avai.INDEX + Slot; j++) {
              allDay[j].id = avai.id;
              allDay[j].status = avai.status;
            }
          }
        }
      }
      if (!mini) {
        if (allDay[startIndex] && allDay[startIndex].status === 3) {
          for (let w = startIndex - Slot; w > startIndex - Slot; w--) {
            if (allDay[w]) {
              allDay[w].status = allDay[w].status == 0 ? 0 : 4;
            }
          }
        }
      }
    });

  let RowArr = [1, 46];
  if (DateStatus && DateStatus.length > 0) {
    RowArr = [];
    for (let i = 0; i < 7; i++) {
      for (let j = i * 48; j < (i + 1) * 48; j++) {
        let row = i > 0 ? j % (48 * i) : j;
        if (allDay[j].status === 3 || allDay[j].status === 1) {
          RowArr.push(row);
        }
      }
    }
  }

  let min = Math.min.apply(Math, RowArr) - 1;
  let max = Math.max.apply(Math, RowArr) + Slot;
  let chunk = max - min;
  let trimmedDay = allDay;
  if (min !== 0 || max !== 336) {
    trimmedDay = [];
    for (let i = 0; i < 7; i++) {
      let k = min + 48 * i;
      for (let j = k; j < max + 48 * i; j++) {
        trimmedDay.push({
          ...allDay[j],
          trimIndex: chunk * i + (j - k),
        });
      }
    }
  }
  const WeekGenerate = () => {
    for (let j = 0; j < trimmedDay.length; j += chunk) {
      Week.push({
        day: WeekDay[moment(trimmedDay[j].date_time).day()],
        date_time: {
          day: Number(moment(trimmedDay[j].date_time).format("jDD")),
          month: Number(moment(trimmedDay[j].date_time).format("jMM")),
          year: Number(moment(trimmedDay[j].date_time).format("jYYYY")),
        },
        times: trimmedDay.slice(j, j + chunk),
      });
    }
  };
  const nextWeekHandler = (callback) => {
    let nextWeekStartEpoche =
      moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day)) +
      7 * 24 * 60 * 60 * 1000;
    let StartDay = {
      ...firstDay,
      Day: Number(moment(nextWeekStartEpoche).format("D")),
      Month: Number(moment(nextWeekStartEpoche).format("M") - 1),
      Year: Number(moment(nextWeekStartEpoche).format("YYYY")),
    };
    setFirstDay(StartDay);
    if (callback) {
      callback(StartDay);
    }
  };
  const previousWeekHandler = (callback) => {
    let nextWeekStartEpoche =
      moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day)) -
      7 * 24 * 60 * 60 * 1000;
    let StartDay = {
      ...firstDay,
      Day: Number(moment(nextWeekStartEpoche).format("D")),
      Month: Number(moment(nextWeekStartEpoche).format("M") - 1),
      Year: Number(moment(nextWeekStartEpoche).format("YYYY")),
    };
    setFirstDay(StartDay);
    if (callback) {
      callback(StartDay);
    }
  };
  const onMouseEnter = (each, i) => {
    if (
      Refs[i] &&
      each.status === 1 &&
      ((trimmedDay[i + Slot - 1] && trimmedDay[i + Slot - 1].status === 1) ||
        (trimmedDay[i + Slot - 1] && trimmedDay[i + Slot - 1].status === 4))
    ) {
      Refs[i].classList.add("o__AvailabiltySchedule__Cell--ReadyToBook");
      Refs[i + Slot - 1].classList.add(
        "o__AvailabiltySchedule__Cell--ReadyToBook"
      );
    }
  };
  const onMouseLeave = () => {
    Refs.forEach((each) =>
      each.classList.remove("o__AvailabiltySchedule__Cell--ReadyToBook")
    );
  };
  const DropdownHandler = () => {
    setShowDropdown(true);
  };
  const removeFromDropdown = (booked, leftChoise, callback) => {
    let newDateStatus = [...DateStatus];
    let bookedIndex = newDateStatus.findIndex((each) => each === booked);
    newDateStatus.splice(bookedIndex, 1);
    setDateStatus(newDateStatus);
    let newTimeSlot;
    if (localSave === true) {
      if (localBook) {
        newTimeSlot = localBook.TimeSlots.filter(
          (each) => each.id !== booked.id
        );
        localBook.TimeSlots = newTimeSlot;
      }
      LocalBooking.Set(localBook);
    }
    if (callback) {
      callback(leftChoise);
    }
  };

  const DropOutSideClick = (e) => {
    if (DropRef && DropRef.current) {
      if (!DropRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    }
  };

  WeekGenerate();

  useMemo(() => {
    setDateStatus(Data);
  }, [Data]);

  useLayoutEffect(() => {
    moment.locale("en");
    setDidMount(true);
  }, []);

  useEffect(() => {
    setWeeklyCell(Week);
    window.addEventListener("mousedown", DropOutSideClick, false);
    return () => {
      window.removeEventListener("mousedown", DropOutSideClick, false);
    };
  }, [DateStatus]);

  const CellClickHandler = (
    cell,
    index,
    leftChoise,
    selectHandler,
    deselectHandler
  ) => {
    if (!mini) {
      if (
        cell.status === 1 &&
        (allDay[index + Slot - 1].status === 1 ||
          allDay[index + Slot - 1].status === 4)
      ) {
        let newDateStatus = [...DateStatus];
        let CellDateTime = {
          Year: Number(moment(allDay[index][`date_time`]).format("YYYY")),
          Month: Number(moment(allDay[index][`date_time`]).format("MM")),
          Day: Number(moment(allDay[index][`date_time`]).format("DD")),
          Hour: Number(moment(allDay[index][`date_time`]).format("HH")),
          Min: Number(moment(allDay[index][`date_time`]).format("mm")),
        };
        let nextCellDateTime = moment(
          new Date(
            CellDateTime.Year,
            CellDateTime.Month - 1,
            CellDateTime.Day,
            CellDateTime.Hour,
            CellDateTime.Min + Slot * 30,
            0
          )
        ).format("YYYY-MM-DDTHH:mm:ssZ");
        let newDateObj = {
          id: cell.id,
          INDEX: index,
          date_time_from: cell[`date_time`],
          date_time_to: nextCellDateTime,
          status: 3,
        };
        if (
          DateStatus.filter((each) => each.status === 3).length <
            SessionCount &&
          SessionCount > 1
        ) {
          if (!newDateStatus.includes(cell)) {
            newDateStatus.push(newDateObj);
            setDateStatus(newDateStatus);
            if (localSave === true && localBook) {
              localBook.TimeSlots.push(newDateObj);
              LocalBooking.Set(localBook);
            }
            selectHandler(newDateStatus);
          }
        } else if (SessionCount == 1) {
          newDateStatus = newDateStatus.filter((each) => !each.id);
          newDateStatus.push(newDateObj);
          setDateStatus(newDateStatus);
          if (localSave === true) {
            localBook.TimeSlots = [];
            localBook.TimeSlots.push(newDateObj);
            LocalBooking.Set(localBook);
          }
          selectHandler(newDateStatus);
        } else {
          return null;
        }
      } else if (cell.status === 3) {
        let newDateStatus = [...DateStatus];
        let CellIndex = newDateStatus.findIndex((each) => each.id === cell.id);
        allDay[cell.INDEX].status = StatusObj.Available;
        newDateStatus.splice(CellIndex, 1);
        setDateStatus(newDateStatus);
        if (localSave === true) {
          let localIndex = localBook.TimeSlots.findIndex(
            (each) => each.id === cell.id
          );
          localBook.TimeSlots.splice(localIndex, 1);
          LocalBooking.Set(localBook);
        }
        deselectHandler(leftChoise, newDateStatus);
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  let currentMonth = [
    ...new Set([
      ...Week.map((each) => {
        return each.date_time.month;
      }),
    ]),
  ];

  let currentMonthYear = [
    ...new Set([
      ...Week.map((each) => {
        return each.date_time.year;
      }),
    ]),
  ].reverse();

  let currentMonthStr = () => {
    let str = "";
    let CurrentMonthArr = [];
    currentMonth.forEach((each, index) => {
      CurrentMonthArr.push(PersianMonth[each - 1]);
    });
    str = `${CurrentMonthArr.join(" - ")}`;
    return <div>{str}</div>;
  };

  let currentYearStr = () => {
    let str = "";
    let CurrentYearArr = [];
    currentMonthYear.forEach((each, index) => {
      if (
        index !== currentMonthYear.length - 1 &&
        currentMonthYear.length > 1
      ) {
        let eachStr = each.toString();
        CurrentYearArr.push(`${eachStr[2] + "" + eachStr[3]}`);
      } else {
        CurrentYearArr.push(each);
      }
    });
    str = `${CurrentYearArr.join(" - ")}`;
    return <div>{str}</div>;
  };

  let ButtonDisable =
    firstDay.Month === todayMonth && firstDay.Day - todayDate <= 6;

  if (!didMount || weeklyCell.length === 0) {
    return null;
  }

  return (
    <Col
      className="l__AvailabiltySchedule"
      xl={24}
      lg={24}
      md={24}
      sm={24}
      xs={24}
    >
      <Col
        xl={23}
        lg={23}
        md={23}
        sm={23}
        xs={23}
        className="c__AvailabiltySchedule__Action"
      >
        <Col
          xl={mini ? 24 : 5}
          lg={mini ? 24 : 6}
          md={mini ? 24 : 6}
          sm={mini ? 24 : 12}
          xs={mini ? 24 : 12}
          className="c__AvailabiltySchedule__WeekController"
        >
          <Col
            xl={6}
            lg={6}
            md={6}
            sm={6}
            xs={6}
            className="o__WeekController__CurrentMonthYear"
          >
            {currentMonthStr()}
            {currentYearStr()}
          </Col>
          <Col className="c__WeekController__Button">
            <Col
              className={`${
                ButtonDisable === true
                  ? "o__WeekController__Button--OFF"
                  : "o__WeekController__Button"
              }`}
              onClick={
                ButtonDisable === false
                  ? () => previousWeekHandler(onPreviousWeek)
                  : null
              }
            >
              <Image src={nextIcon} />
            </Col>
            <Col
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={6}
              className="o__WeekController__Button"
              onClick={() => nextWeekHandler(onNextWeek)}
            >
              <Image src={previousIcon} />
            </Col>
          </Col>
        </Col>

        {!mini && (
          <>
            <Col
              xl={14}
              lg={12}
              md={12}
              sm={0}
              xs={0}
              className="o__AvailabiltySchedule__Notif"
            >
              {role === "Teacher" && (
                <Col
                  style={{
                    color: theme.danger,
                    fontWeight: 800,
                    backgroundColor: theme.danger,
                    padding: "5px 15px 5px 15px",
                    borderRadius: "7px",
                    color: "white",
                    fontSize: theme.fontSizeSm,
                  }}
                >
                  شما به عنوان استاد در سایت وارد شده اید و امکان رزرو کلاس
                  ندارید
                </Col>
              )}
            </Col>

            <Col
              xl={5}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              onClick={DropdownHandler}
              className="c__AvailabiltySchedule__SessionController"
            >
              {!mini && SessionCount > 1 && (
                <Col className="o__SessionController__Dropdown">
                  {leftChoise > 0 ? (
                    <Col>
                      {`${leftChoise} جلسه برای زمان بندی باقیمانده است `}
                    </Col>
                  ) : (
                    "همه جلسات انتخاب شده اند"
                  )}
                </Col>
              )}
              <Col
                className="o__SessionController__Dropdown__Content"
                innerRef={DropRef}
                style={{
                  display: showDropdown ? "flex" : "none",
                }}
              >
                {DateStatusInBook.length > 0 &&
                  DateStatusInBook.map((booked, index) => {
                    return (
                      <Col xl={24} lg={24} md={24} sm={24} md={24}>
                        <Col
                          className="o__Dropdown__Content__Index"
                          xl={4}
                          lg={4}
                          md={4}
                          sm={4}
                          md={4}
                        >
                          {index + 1}
                        </Col>
                        <Col
                          className="o__Dropdown__Content__Detail"
                          xl={18}
                          lg={18}
                          md={18}
                          sm={18}
                          md={18}
                        >
                          {DateTime.getDayFullStr(
                            `${moment(booked.date_time_from).format("ddd")}`
                          )[`${lang}`] +
                            " , " +
                            moment(booked.date_time_from).format("jDD") +
                            " " +
                            PersianMonth[
                              Number(
                                moment(booked.date_time_from).format("jMM")
                              ) - 1
                            ] +
                            " - " +
                            moment(booked.date_time_from).format("HH") +
                            ":" +
                            moment(booked.date_time_from).format("mm") +
                            " تا " +
                            moment(booked.date_time_to).format("HH") +
                            ":" +
                            moment(booked.date_time_to).format("mm")}
                        </Col>
                        <Col
                          className="o__Dropdown__Content__Remove"
                          xl={4}
                          lg={4}
                          md={4}
                          sm={4}
                          md={4}
                        >
                          <Image
                            onClick={() =>
                              removeFromDropdown(booked, leftChoise, onRemove)
                            }
                            src={closeIcon}
                          />
                        </Col>
                      </Col>
                    );
                  })}
              </Col>
            </Col>
          </>
        )}
      </Col>
      <Col
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        className="c__AvailabiltySchedule__TopBar"
      >
        <Col
          className="o__AvailabiltySchedule__Day"
          xl={breakPoints ? breakPoints.xl : 16}
          lg={breakPoints ? breakPoints.lg : 16}
          md={breakPoints ? breakPoints.md : 21}
          sm={breakPoints ? breakPoints.sm : 21}
          zs={breakPoints ? breakPoints.xs : 21}
        >
          {weeklyCell.length > 0 &&
            weeklyCell.map((day) => {
              return (
                <Col
                  xl={20.5 / 7}
                  lg={20.5 / 7}
                  md={20.5 / 7}
                  sm={20.5 / 7}
                  xs={20.5 / 7}
                  className="o__AvailabiltySchedule__Day__Title"
                  style={{
                    ...props.titleStyle,
                  }}
                >
                  {/* {!breakPoints ?
                                    DateTime.getDayFullStr(day.day)[`${props.lang}`] + ' , ' + day.date_time.day + ' ' + (width > 992 ? PersianMonth[day.date_time.month - 1] : '')
                                    : */}
                  {/* <> */}
                  <Col>{DateTime.getDayFullStr(day.day)[`${props.lang}`]}</Col>
                  <Col>
                    {day.date_time.day +
                      " " +
                      PersianMonth[day.date_time.month - 1]}
                  </Col>
                  {/* </> */}
                  {/* } */}
                </Col>
              );
            })}
        </Col>
      </Col>
      {loading === false && Data.length > 0 && (
        <Col
          className="c__AvailabiltySchedule"
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
        >
          <Col
            xl={breakPoints ? breakPoints.xl : 16}
            lg={breakPoints ? breakPoints.lg : 16}
            md={breakPoints ? breakPoints.md : 21}
            sm={breakPoints ? breakPoints.sm : 21}
            zs={breakPoints ? breakPoints.xs : 21}
            className="c__AvailabiltySchedule__Guide"
          >
            <Col
              className="o__Guide__Timezone"
              xl={8}
              lg={8}
              md={8}
              sm={8}
              xs={8}
            >
              بر اساس وقت محلی شما {DateTime.timeZone()}
            </Col>
            <Col
              className="c__Guide__Status"
              xl={16}
              lg={16}
              md={16}
              sm={16}
              xs={16}
            >
              {StatusList(theme).map((status) => {
                return (
                  <Col className="o__Guide__Status">
                    <Col
                      xl={4}
                      lg={4}
                      md={4}
                      sm={4}
                      xs={4}
                      className={`${
                        status.value == 2
                          ? "o__Guide__Status__Circle--Booked"
                          : status.value == 0
                          ? "o__Guide__Status__Circle--NotAvailable"
                          : null
                      } o__Guide__Status__Circle`}
                      style={{
                        backgroundColor: status.color,
                      }}
                    ></Col>
                    <Col className="o__Guide__Status__Value">{status.desc}</Col>
                  </Col>
                );
              })}
            </Col>
          </Col>
          <Col
            xl={breakPoints ? breakPoints.xl : 16}
            xl={breakPoints ? breakPoints.xl : 16}
            lg={breakPoints ? breakPoints.lg : 16}
            md={breakPoints ? breakPoints.md : 21}
            sm={breakPoints ? breakPoints.sm : 21}
            zs={breakPoints ? breakPoints.xs : 21}
            className="o__AvailabiltySchedule"
            style={{
              height: props.size * (row + 1) + "px",
            }}
          >
            <Col
              xl={3.5}
              lg={24 / 7}
              md={4}
              sm={4}
              xs={4}
              className="c__AvailabiltySchedule__Hours"
            >
              <Col
                className="o__AvailabiltySchedule__Hours"
                style={{
                  paddingBottom: `${props.size / 2}px`,
                }}
              >
                {weeklyCell.length > 0 &&
                  weeklyCell[0].times.map((hours, index) => {
                    return (
                      index > 0 && (
                        <Col
                          style={{
                            height: `${props.size}px`,
                            marginTop: index === 1 && `${props.size / 2}px`,
                          }}
                          key={hours.Start}
                        >
                          {(hours.startHour < 10
                            ? "0" + hours.startHour
                            : hours.startHour) +
                            ":" +
                            (hours.startMin === 0 ? "00" : hours.startMin)}
                        </Col>
                      )
                    );
                  })}
              </Col>
            </Col>
            <Col
              xl={20.5}
              lg={(24 * 6) / 7}
              md={21}
              sm={21}
              xs={21}
              className="c__AvailabiltySchedule__DayStatus"
            >
              {weeklyCell.length > 0 &&
                weeklyCell.map((day, IndexRow) => {
                  return (
                    <Col
                      xl={24 / 7}
                      lg={24 / 7}
                      md={24 / 7}
                      sm={24 / 7}
                      xs={24 / 7}
                      className="o__AvailabiltySchedule__Day__Column"
                      key={IndexRow}
                    >
                      {day.times.map((time, IndexColumn) => {
                        let trmINDEX = time.trimIndex;
                        return (
                          <Col
                            className={` ${
                              time.status === 2
                                ? "o__AvailabiltySchedule__Cell--Booked"
                                : time.status === 3
                                ? "o__AvailabiltySchedule__Cell--BookedByYou"
                                : time.status === 4
                                ? "o__AvailabiltySchedule__Cell--Deactive"
                                : null
                            } o__AvailabiltySchedule__Cell`}
                            height="auto"
                            style={{
                              ...props.dayStyle,
                              backgroundColor:
                                time.status === 1 && theme.calendarGreen,
                              color: time.status === 1 && "white",
                              cursor:
                                time.status === 2 ||
                                (SessionCount > 1 &&
                                  leftChoise === 0 &&
                                  time.status !== 3)
                                  ? "no-drop"
                                  : "pointer",
                              height: `${props.size}px`,
                            }}
                            key={time.Start}
                            innerRef={setRef}
                            onMouseEnter={
                              !mini ? () => onMouseEnter(time, trmINDEX) : null
                            }
                            onMouseLeave={!mini ? onMouseLeave : null}
                            onClick={() =>
                              CellClickHandler(
                                time,
                                time.INDEX,
                                leftChoise,
                                onSelect,
                                onDeselect
                              )
                            }
                          >
                            {time.status > 0 &&
                              trimmedDay[trmINDEX + Slot - 1] &&
                              trimmedDay[trmINDEX + Slot - 1].status > 0 && (
                                <Col
                                  xl={24}
                                  lg={24}
                                  md={24}
                                  sm={24}
                                  xs={24}
                                  style={{
                                    height: `${2 * props.size}px`,
                                    display: mini && "none",
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                  className={
                                    IndexRow > 5 && IndexColumn !== 47
                                      ? "o__AvailabiltySchedule__Cell--TooltipLastCol"
                                      : IndexColumn === 47 && IndexRow <= 5
                                      ? "o__AvailabiltySchedule__Cell--TooltipLastRow"
                                      : IndexRow > 5 && IndexColumn === 47
                                      ? "o__AvailabiltySchedule__Cell--TooltipLastColLastRow"
                                      : "o__AvailabiltySchedule__Cell--Tooltip"
                                  }
                                >
                                  {(time.status === 1 ||
                                    time.status === 3 ||
                                    time.status === 4) && (
                                    <>
                                      <Col>
                                        {
                                          DateTime.getDayFullStr(
                                            `${moment(time.date).format("ddd")}`
                                          )[`${lang}`]
                                        }
                                        ,{" "}
                                        {moment(time.date_time).format("jDD") +
                                          " " +
                                          PersianMonth[
                                            Number(
                                              moment(time.date_time).format(
                                                "jMM"
                                              )
                                            ) - 1
                                          ]}
                                      </Col>
                                      {
                                        <Col>
                                          {(time.startHour < 10
                                            ? "0" + time.startHour
                                            : time.startHour) +
                                            ":" +
                                            (time.startMin === 0
                                              ? "00"
                                              : time.startMin) +
                                            " تا " +
                                            (allDay[trmINDEX + 1] &&
                                            allDay[trmINDEX + 1].endHour < 10
                                              ? "0" +
                                                trimmedDay[trmINDEX + Slot - 1]
                                                  .endHour
                                              : trimmedDay[trmINDEX + Slot - 1]
                                                  .endHour) +
                                            ":" +
                                            (trimmedDay[trmINDEX + Slot - 1]
                                              .endMin === 0
                                              ? "00"
                                              : trimmedDay[trmINDEX + Slot - 1]
                                                  .endMin)}
                                        </Col>
                                      }
                                    </>
                                  )}
                                  {time.status === 2 && (
                                    <Col> رزرو شده توسط دیگران</Col>
                                  )}
                                </Col>
                              )}
                            {/* {
                                                            `${time.id}`
                                                        } */}
                          </Col>
                        );
                      })}
                    </Col>
                  );
                })}
            </Col>
          </Col>
        </Col>
      )}
      {loading === true && (
        <Col
          className="c__AvailabiltySchedule"
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          style={{
            justifyContent: "center",
          }}
        >
          <Loader height={150} />
        </Col>
      )}
      {hasData === false && Data.length === 0 && (
        <Col className="c__Loading" xl={24} lg={24} md={24} sm={24} xs={24}>
          <Col
            style={{
              backgroundColor: theme.warning,
              color: "white",
              padding: "5px",
              height: "40px",
            }}
            xl={24}
            lg={24}
            md={24}
            sm={24}
            xs={24}
          >
            برای هفته انتخاب شده زمان آزاد وجود ندارد.
          </Col>
        </Col>
      )}
    </Col>
  );
};
export default AvailabiltySchedule;
